<template>
  <div>
    <v-dialog class="card-height" v-model="visible" max-width="800px">
      <v-card>
        <v-toolbar color="#f9f9f9">
          <v-toolbar-title>{{noticeList[typeAig].name}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
            <p v-html="noticeList[typeAig].value"></p>
        </v-card-text>
        <div v-if="isnoPay == 0" style="display:flex;justify-content:center">
            <v-btn color="primary" :loading="payLoding" @click="nextStep">{{typeAig>=5?'去支付':'确认'}}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import insure from '@/assets/js/insure'
import dutiyFree from '@/assets/js/dutiyFree'
import insureMan from '@/assets/js/insureMan'
import insureFront from '@/assets/js/insureFront'
import custom from '@/assets/js/custom'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type:{
        type:Number,
        default:0
    },
    isnoPay:{
        type:Number,
        default:1
    }
  },
  data(){
    return{
        payLoding:false,
        typeAig:0,
        noticeList:[
            {
                name:'投保须知',
                value:insure
            },
            {
                name:'责任免除',
                value:dutiyFree
            },
            {
                name:'投保前提条件告知',
                value:insureMan
            },
            {
                name:'投保人声明及确认',
                value:insureFront
            },
            {
                name:'保险经纪服务授权委托书',
                value:custom
            },
            {
                name:'客户告知书',
                value:custom
            },
        ],
    }
  },
  computed: {
    visible: {
      get() {
        this.typeAig = this.type
        let ele = document.getElementsByClassName('v-dialog--active')[0]
        if(ele){
            ele.scrollTop = 0
        }
        this.payLoding = false
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  },
  methods:{
      nextStep(){
        if(this.typeAig >=5 ){
            this.payLoding = true
            this.$emit('changeType','canpay')
            return
        }
        let ele = document.getElementsByClassName('v-dialog--active')[0]
        ele.scrollTop = 0
        this.typeAig++
        this.$emit('changeType',this.typeAig)
      }
  }
};
</script>



